import { navItems } from "constants";
import { HashLink as Link } from "react-router-hash-link";

export function Menu({ setOpenMenu, activeTab, darkMode }) {
  return (
    <nav
      className="fixed top-20 right-0 w-full bg-nav border-t border-border flex flex-col py-6 z-50 shadow-xl 
      transition-all duration-300 ease-in-out animate-slideDown md:hidden rounded-b-xl"
    >
      <ul className="flex flex-col gap-1 w-full px-4 font-medium text-base">
        {navItems.map((item) => (
          <li key={item.to}>
            <Link
              to={`${item.to}`}
              smooth
              onClick={() => {
                setOpenMenu(false);
              }}
              className={`block px-4 py-2 hover:text-accent transition-all duration-200 ${
                activeTab === item.to
                  ? "text-accent font-semibold border-l-4 border-accent"
                  : darkMode
                    ? "text-muted"
                    : "text-main"
              }`}
            >
              {item.label}
            </Link>
          </li>
        ))}
      </ul>
    </nav>
  );
}
